// import 'antd/es/date-picker/style/index';

import generatePicker from 'antd/es/date-picker/generatePicker';

import dayjsGenerateConfig from '../../../../node_modules/rc-picker/lib/generate/dateFns';

const DatePicker = generatePicker<Date>(dayjsGenerateConfig);

export default DatePicker;
